import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../context/store";
import styled from "styled-components";

const AvatarContainer = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 500;
`;

const StaffImg = ({ staff_id }) => {
  const context = useContext(AppContext);
  const [allStaffs, setAllStaffs] = useState([]);

  useEffect(() => {
    const getAllStaffs = async () => {
      try {
        const response = await axios.get(`${context.api_endpoint}/company/staffs/unsafe`);
        setAllStaffs(response.data.data);
      } catch (error) {
        console.error("Personel bilgileri alınırken hata oluştu:", error);
      }
    };

    getAllStaffs();
  }, [context.api_endpoint]);

  const staff = allStaffs.find(s => s.id === parseInt(staff_id));
  const imgEndpoint = context.api_endpoint.replace('/api/v1', '');

  const getInitials = (name, surname) => {
    return `${name?.charAt(0) || ''}${surname?.charAt(0) || ''}`.toUpperCase();
  };

  const renderStaffImage = () => {
    if (staff?.detail?.profile_photo) {
      return (
        <img
          src={`${imgEndpoint}/${context.state.company_id}/${staff.detail.profile_photo}`}
          alt={`${staff.name} ${staff.surname}`}
          style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
        />
      );
    } else {
      return (
        <AvatarContainer>
          {getInitials(staff?.name, staff?.surname)}
        </AvatarContainer>
      );
    }
  };

  return (
    <div style={{ width: '50px', height: '50px' }}>
      {staff && renderStaffImage()}
    </div>
  );
};

export default StaffImg;
